import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { HTTPMethods } from "../../../yoello-lib/modules/API/API";
import { APIExtensions } from "../../../yoello-lib/modules/API2/types.d";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";


type setArrayFunction<T> = (item: T[]) => void;

/**Reuseable hook for saving the products data for the products container*/
export function useProductsData<T>(apiExtension: APIExtensions, venueId: string | undefined, setArrayFunction: setArrayFunction<T>, query = {} , queryParams?:string, preQuery?:string) {
    const { t } = useTranslation();

    const { apiData, callAPI, isLoading } = useAPIV2<T[] | T>(apiExtension,
        { yoelloAPIParams: { venue_id: venueId, size: 200, include_disabled: true, ...query }, isPaginated: true, errorCall: t("api.call.error"),query:queryParams, preQuery });

    useEffect(() => {
        if (apiData) {
            if (Array.isArray(apiData)) {
                setArrayFunction(apiData);
            } else {
                callAPI(HTTPMethods.GET, { 
                    yoelloAPIParams: { venue_id: venueId, size: 200 }, isPaginated: true,query:queryParams});
            }
        }
        // eslint-disable-next-line
    }, [apiData]);
    return {
        callAPI,
        isLoading,

    };
}